module.exports = global["ReactDOM"] = require("-!/home/vvo/Dev/Algolia/instantsearch.js/node_modules/react-dom/index.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/index.js
 ** module id = 373
 ** module chunks = 0
 **/